import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ILabGraphViewProperties } from "./LabGraphView";

class LabGraphSearchComponentState {
    public searchText: string = "";
}

class LabGraphSearchComponent extends BaseReactComponent<ILabGraphViewProperties, LabGraphSearchComponentState> {
    constructor(props: ILabGraphViewProperties) {
        super(props);

        this.state = new LabGraphSearchComponentState();
    }

    public componentDidMount(): void {
        $(window).trigger("resize"); // Resize for when people switch tab and come back
    }

    public render(): JSX.Element {
        let checkboxes = this.props.GraphModel.get("ObservationTypesCheckBoxes").toArray().filterSearch(this.state.searchText, x => x.Name);

        return (
            <div className="lab-graph-search-component" style={{ "marginTop": "15px" }}>
                <div>
                    <TextboxControl
                        value={this.state.searchText}
                        onChange={value => this.mutateState(s => s.searchText = value)}
                    />
                </div>
                <div style={{ "marginBottom": "15px" }}>
                    <CheckboxControl
                        id="all_graphs_check"
                        label={cacheStore.GetString("AllLabInbox").toUpperCase()}
                        operation={LocalOperations.LabsUI.Graphs_CheckboxChange}
                        checked={this.props.GraphModel.get("AreAllGraphsChecked")}
                        target={CheckboxTarget.Myle_Labs_GraphsControl}
                    />
                </div>
                <div className="scrollable" style={{ overflowY: "auto" }}>
                    <CheckedListControl
                        DataSource={checkboxes.toImmutable()}
                        Operation={LocalOperations.LabsUI.Graphs_CheckboxChange}
                        limitTextWidth={true}
                    />
                </div>
            </div>
        );
    }
}

export { LabGraphSearchComponent };
